import { addDays, startOfDay, startOfMonth, subDays } from "date-fns";
import { nowDate } from "@/shared/lib/date-time";
import type { ReportDateBasis } from "./constants";

export type ReportDatePreset = "today" | "7d" | "month" | "custom";

export type ReportDateRangeState = {
  from: string;
  to: string;
  basis: ReportDateBasis;
};

export function buildDateRangePreset(
  preset: ReportDatePreset,
  basis: ReportDateBasis = "created",
): ReportDateRangeState {
  const todayStart = startOfDay(nowDate());
  const tomorrow = addDays(todayStart, 1);

  let from = todayStart;
  if (preset === "7d") {
    from = subDays(todayStart, 6);
  } else if (preset === "month") {
    from = startOfMonth(todayStart);
  }

  return {
    from: from.toISOString(),
    to: tomorrow.toISOString(),
    basis,
  };
}

/** API ใช้ `to` เป็น exclusive — แปลงเป็น inclusive สำหรับ UI */
export function reportRangeToInclusiveEnd(toExclusive: string): Date {
  return subDays(startOfDay(new Date(toExclusive)), 1);
}

export function reportRangeToPickerValue(state: ReportDateRangeState) {
  return {
    from: startOfDay(new Date(state.from)),
    to: reportRangeToInclusiveEnd(state.to),
  };
}

export function buildCustomDateRange(
  from: Date,
  to: Date,
  basis: ReportDateBasis,
): ReportDateRangeState {
  const fromStart = startOfDay(from);
  const toStart = startOfDay(to);
  const safeFrom = fromStart <= toStart ? fromStart : toStart;
  const safeTo = fromStart <= toStart ? toStart : fromStart;

  return {
    from: safeFrom.toISOString(),
    to: addDays(safeTo, 1).toISOString(),
    basis,
  };
}
